import { useEffect, useRef } from 'react';
import { mountRoadPreview } from '@goodtime/engine';
import type { RoadState } from '@goodtime/shared';
import spinResponse from '../../../../../packages/shared/fixtures/road/spin-response.json';
import lampUrl from '../../assets/road/lamp_lens.png';
import bezelUrl from '../../assets/road/light_bezel.png';
import cobblesUrl from '../../assets/road/path_strip.png';
import potSilverUrl from '../../assets/road/pot_silver.png';
import potGoldUrl from '../../assets/road/pot_gold.png';
import lockUrl from '../../assets/icon/lock.png';
import coinUrl from '../../assets/icon/coin.png';
import gemUrl from '../../assets/icon/gem.png';
import spinUrl from '../../assets/icon/spin.png';
import flowerUrl from '../../assets/reel/forest/flower.png';
import floorUrl from '../../assets/reel/forest_column_bg.webp';

const prologue = (spinResponse as unknown as { road: RoadState }).road;
const levelTwo: RoadState = {
  ...prologue,
  trail: {
    ...prologue.trail,
    level: 2,
    position: 2,
    meter: 9,
    cost: 22,
    squares: ['start', 'coins:24', 'gems:1', 'coins:41', 'fs:3', 'coins:57', 'gems:2', 'run'],
    collected: 0,
  },
};

/** `?dev=road-pixi`: the Pixi road panel in every mode, from the server's fixture. */
export function RoadPixiPreview() {
  const host = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!host.current) return;
    return mountRoadPreview(host.current, {
      urls: {
        lamp: lampUrl, bezel: bezelUrl, cobbles: cobblesUrl, potSilver: potSilverUrl, potGold: potGoldUrl,
        lock: lockUrl, coin: coinUrl, gem: gemUrl, spin: spinUrl, collector: flowerUrl, floor: floorUrl,
      },
      roads: [prologue, levelTwo],
    });
  }, []);
  return <div ref={host} data-testid="road-pixi-preview" style={{ position: 'fixed', inset: 0 }} />;
}
